import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { AbsenceCategoriesLegendComponent } from '../absence-categories-legend/absence-categories-legend.component';

export interface AbsenceCategoriesLegendDialogData {
  categoryId?: number;
}

@Component({
  selector: 'app-absence-categories-legend-dialog',
  templateUrl: './absence-categories-legend-dialog.component.html',
  styleUrl: './absence-categories-legend-dialog.component.css',
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, AbsenceCategoriesLegendComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class AbsenceCategoriesLegendDialogComponent {
  dialogRef = inject<MatDialogRef<AbsenceCategoriesLegendDialogComponent>>(MatDialogRef);
  data = inject<AbsenceCategoriesLegendDialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }
}
